module.exports = __webpack_public_path__ + "fa78d41bc64d9a68160235b9dea0f11a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/goldencity21.jpg
// module id = 772
// module chunks = 0